<template>
    <div>
        <v-container>
            <h3 class="headline mb-3">Lista de Representantes</h3>

            <v-card>
                <v-toolbar flat color="white">
                  <div style="width: 300px;">
                    <v-text-field label="Pesquisar" autofocus flat solo clearable hide-details prepend-inner-icon="search" v-model="search"  class="hidden-sm-and-down"></v-text-field>
                  </div>

                  <v-btn-toggle v-show="false" v-model="listagem" mandatory class="elevation-1">
                    <v-btn value="Recentes" flat>
                      Recentes
                    </v-btn>
                    <v-btn value="Todos" flat>
                      Todos
                    </v-btn>
                  </v-btn-toggle>
                  
                  <v-spacer></v-spacer>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-btn="on" icon @click="listar" :loading="$store.state.loading">
                        <v-icon>refresh</v-icon>
                      </v-btn>
                    </template>
                    Atualizar
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-btn="on" fab small color="primary" to="/cadastros/representantes/adicionar">
                        <v-icon>person_add</v-icon>
                      </v-btn>
                    </template>
                    Adicionar Representante
                  </v-tooltip>
                </v-toolbar>

                <v-divider></v-divider>

                <v-data-table :headers="headers" :items="representantes" item-key="id" :loading="false" :search="search">
                <template v-slot:item="props">
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.razao }}</td>
                    <td>{{ props.item.telefone }}</td>
                    <td class="text-center">
                      <v-btn depressed outline icon fab dark color="primary" small @click="editar(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <v-btn depressed outline icon fab dark color="pink" small @click="perguntarExcluir(props.item)">
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                </template>
                </v-data-table>
            </v-card>
        </v-container>


      <z-dialogo ref="dialogoExcluir" titulo="Deseja excluir esse representante?" :dividers="true" largura="500px">
        <div slot="texto">
          <v-list>

            <v-list-item>
              <v-list-item-action>
                <v-icon color="indigo">mail</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ representante.razao }}</v-list-item-title>
                <v-list-item-subtitle>Razão Social</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset v-show="representante.telefone"></v-divider>

            <v-list-item v-show="representante.telefone">
              <v-list-item-action>
                <v-icon color="indigo">phone</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ representante.telefone }}</v-list-item-title>
                <v-list-item-subtitle>Telefone</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

          </v-list>
        </div>

        <v-btn text @click="$refs.dialogoExcluir.fechar()" :disabled="excluindo">Cancelar</v-btn>
        <v-btn color="primary darken-1" text @click="confirmarExcluir" :loading="excluindo" :disabled="excluindo">Excluir</v-btn>

      </z-dialogo>
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      // globals,
      headers: [
        { text: "Código", value: "id", width: "150px" },
        { text: "Razão Social", value: "razao" },
        { text: "Telefone", value: "telefone" },
        { text: "Opções", value: "", width: "200px", align: "center", sortable: false }
      ],
      search: "",
      pagination: {},
      excluindo: false,
      representante: {},
      listagem: 'Recentes'
    };
  },

  created() {
    // this.setTitulo('Cadastro de Representantes');
    this.listar();
  },

  methods: {
    ...mapMutations(['setTitulo']),
    ...mapActions('representantes', ['listar', 'excluir', 'abrir']),

    async editar(representante) {
      await this.abrir(representante.id);
      this.$router.push({ name: "RepresentantesEditar", params: { id: representante.id } });
    },

    perguntarExcluir(representante) {
      this.representante = representante;
      this.$refs.dialogoExcluir.abrir();
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.representante.id);
      } finally {
        this.$refs.dialogoExcluir.fechar();
        this.excluindo = false;
        this.$eventbus.notificar('Representante excluído com sucesso!');
      }
    }
  },

  computed: {
    ...mapState("representantes", ["representantes"])
  }
};
</script>

<style scoped>
</style>
